import React from 'react'

const Counter = () => {
  return (
    <>
     
        <section className="counter z-3 pt-50 pb-90" style={{backgroundColor: "#C4EF17"}}>
            <div className="container">
                <div className="counter-wrap ul_li_between">
                    <div className="xb-couter-box ul_li">
                        <div className="xb-item--icon">
                            <img src="assets/img/icon/coun_01.svg" alt=""/>
                        </div>
                        <div className="xb-item--holder">
                            <h3 className="xb-item--title xb-odm"><span className="xbo" data-count="345">00</span><span className="suffix">+</span></h3>
                            <p className="xb-item--content">Projects Completed</p>
                        </div>
                    </div>
                    <div className="xb-couter-box ul_li">
                        <div className="xb-item--icon">
                            <img src="assets/img/icon/coun_02.svg" alt=""/>
                        </div>
                        <div className="xb-item--holder">
                            <h3 className="xb-item--title"><span className="xbo" data-count="12">00</span></h3>
                            <p className="xb-item--content">Team Members</p>
                        </div>
                    </div>
                    <div className="xb-couter-box ul_li">
                        <div className="xb-item--icon">
                            <img src="assets/img/icon/coun_03.svg" alt=""/>
                        </div>
                        <div className="xb-item--holder">
                            <h3 className="xb-item--title"><span className="xbo" data-count="35">00</span><span className="suffix">+</span></h3>
                            <p className="xb-item--content ">Social Media<br className='spl-br'/>    Accounts Managed</p>
                        </div>
                    </div>
                    <div className="xb-couter-box ul_li">
                        <div className="xb-item--icon">
                            <img src="assets/img/icon/coun_04.svg" alt=""/>
                        </div>
                        <div className="xb-item--holder">
                            <h3 className="xb-item--title"><span className="xbo" data-count="2">00</span><span className="suffix pcsufff">million</span><span className="suffix mobSufff">M</span></h3>
                            <p className="xb-item--content">Influencer <br className='influ-br'/> Reach Network</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
    </>
  )
}

export default Counter
